import { useEffect, useState } from "react";
import { getData } from "../../../../Services/Services";
import { getThemeURL } from "../../../../Services/EndPoints";

// Permission ids of the fleet modules (same ids as navLinksData.js / Create Role)
export const FLEET_PERMISSION_IDS = {
  VEHICLE_MANAGEMENT: 85,
  CREATE_ASSIGN_ROUTE: 86,
  PLANNED_ROUTE: 87,
  GPS_TRACKING: 88,
  TRIP_TRACKER: 90,
  ACCIDENTS_HISTORY: 91,
  CREATE_ASSIGN_GEOFENCE: 93,
  GEOFENCING_LIST: 94,
  OTA_MANAGEMENT: 95,
  FACIAL_REGISTRATION: 97,
  FACIAL_DETECTION: 98,
  LIVE_CROWD_MONITORING: 99,
};

/**
 * View / Edit / Delete rights of the logged-in user for one module — same rule as the bank pages
 * (BankTable etc.): GET /user_profile/getUserProfile → permissions[] → the entry with this id →
 * web_permissions "V,E,D". Until the profile is loaded (or if the module isn't assigned) all are false.
 */
export default function useModulePermissions(permissionId) {
  const [perms, setPerms] = useState({ canView: false, canEdit: false, canDelete: false, loaded: false });

  useEffect(() => {
    let cancelled = false;
    getData(getThemeURL).then((res) => {
      if (cancelled) return;
      const permissions = Array.isArray(res) ? res[0]?.permissions : null;
      const entry = Array.isArray(permissions) ? permissions.find((p) => p.id === permissionId) : null;
      const codes = (entry?.web_permissions || "").split(",").map((c) => c.trim().toUpperCase());
      setPerms({
        canView: codes.includes("V"),
        canEdit: codes.includes("E"),
        canDelete: codes.includes("D"),
        loaded: true,
      });
    });
    return () => { cancelled = true; };
  }, [permissionId]);

  return perms;
}
